import React, { useState, useEffect, useContext } from "react"
import { useSelector, useStore } from "react-redux"
import { useHistory } from "react-router-dom"

import { CenterModalCallbackContext } from "context/popup/CenterModalProvider"
import ConfirmCenterModal from "components/presenters/popup/ConfirmCenterModal/ConfirmCenterModal"
import RoutineCreateForm from "components/containers/routine/RoutineCreateForm"
import RoutineSelectCalendar from "components/containers/routine/RoutineSelectCalendar"

import serverController from "server/serverController"
import { Routineinner } from "./style"

export default function CreateRoutineLayout({ match }) {
	const { openCenterModal, closeCenterModal } = useContext(CenterModalCallbackContext)
	const userInfo = useSelector((state) => {
		return state.userInfo
	})
	const history = useHistory()
	const store = useStore()

	const [isSubmitted, setIsSubmitted] = useState(false)
	const [todotext, setTodotext] = useState("")
	const [todoalarm, setTodoalarm] = useState("")
	const [rutineDay, setRutineDay] = useState("")
	const [rutineWeek, setRutineWeek] = useState("")
	const [selectResult, setSelectResult] = useState([])
	//RoutinState
	// 페이지 이동
	const [screenIndex, setScreenIndex] = useState(0)

	let titleText = "루틴 시작날짜 / 요일"

	const [submitDay, setSubmitDay] = useState()
	const updateNext = (index) => {
		// 페이지 더 생성되면 숫자 늘려나가기
		if (screenIndex + index === -1 || screenIndex + index > 2) return
		setScreenIndex(screenIndex + index)
	}

	//루틴생성 데이터 보내기
	const callBack = (res) => {
		setIsSubmitted(false)
		if (res.success === 1) {
			history.goBack()
		} else {
			let state = store.getState()
			let errState = state["errorStateInfo"]
			let errFlag = errState["fetchErrTriggerd"]
			const dataList = {
				confirmTxt: "확인",
			}
			let onModalComplete = (id) => closeCenterModal(id)
			if (!errFlag && res["error"] && res["error"]["res_data"]) {
				let errData = res["error"]["res_data"]
				if (errData["detail_code"] === "LOGIN_REQ") {
					dataList.description = "로그인이 필요합니다."
					onModalComplete = (id) => {
						closeCenterModal(id)
						history.replace("/social")
					}
				} else if (errData["detail_code"] === "GROUP_DOES_NOT_EXIST") {
					dataList.description = "해당 그룹은 존재하지 않습니다."
				} else if (errData["detail_code"] === "INVALID_START_DATE") {
					dataList.description = "불가능한 시작 날짜 입니다."
				} else if (errData["detail_code"] === "INVALID_EMPTY_DAY") {
					dataList.description = "요일을 설정해주세요."
				} else if (errData["detail_code"] === "FAILED_TO_PASS_REQUIRED_FIELD_CHECK") {
					let missedFields = errData["missed_fields"]

					if (missedFields.includes("title")) {
						dataList.description = "제목을 설정해주세요"
					} else if (missedFields.includes("start_date")) {
						dataList.description = "시작 날짜를 설정해주세요."
					} else if (missedFields.includes("day")) {
						dataList.description = "요일을 설정해주세요."
					} else {
						dataList.description = "루틴 추가를 위한 양식을 작성해 주세요."
					}
				} else {
					alert("예기치 못한 오류가 발생하였습니다.")
				}

				openCenterModal({
					Component: (
						<ConfirmCenterModal dataList={dataList} onComplete={onModalComplete} />
					),
				})
			}
		}
	}

	/*--click block--*/
	const dataSubmit = () => {
		if (isSubmitted) return
		setIsSubmitted(true)

		let data = {
			title: todotext,
			start_date: submitDay,
			day: rutineWeek,
		}
		serverController.generalPostFetchController(
			`tasks/routines`,
			JSON.stringify(data),
			callBack
		)
	}

	const renderPageController = () => {
		switch (screenIndex) {
			case 0:
				return (
					<RoutineCreateForm
						userInfo={userInfo}
						updateNext={updateNext}
						dataSubmit={dataSubmit}
						todoalarm={todoalarm}
						setTodoalarm={setTodoalarm}
						todotext={todotext}
						setTodotext={setTodotext}
						rutineDay={rutineDay}
						rutineWeek={rutineWeek}
						selectResult={selectResult}
					/>
				)
			case 1:
				return (
					<RoutineSelectCalendar
						updateNext={updateNext}
						setRutineDay={setRutineDay}
						setRutineWeek={setRutineWeek}
						titleText={titleText}
						setSubmitDay={setSubmitDay}
						selectResult={selectResult}
						setSelectResult={setSelectResult}
					/>
				)
			default:
				break
		}
	}

	return <Routineinner>{renderPageController()}</Routineinner>
}
